

import Preview from "./preview.js";


class Bookmarks extends Preview {
    _parentEl = document.querySelector('.bookmarks__list');
    _errorMessage = "No bookmarks yet. Find a nice recipe and bookmark it :)";

    
    addHandlerLoadBookmarks(handler) {
        window.addEventListener("load", handler);
    }
}


export default new Bookmarks();